import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-reaction',
  templateUrl: './reaction.component.html',
  styleUrls: ['./reaction.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class ReactionComponent implements OnInit {

  @Input() reactions: Map<string, []>;
  @Input() id: string;
  @Input() userID: string;
  @Output() reaction: EventEmitter<any> = new EventEmitter();
  userReaction: string;

  constructor() { }

  ngOnChanges() {
    this.getUserReaction();
  }

  ngOnInit() {
  }

  getUserReaction() {
    if(this.reactions){
      for (let [key, value] of Object.entries(this.reactions)) {
        value.forEach((element: Map<string, string>) => {
          if (element['domainID'] == this.userID) {
            this.userReaction = key;
            return;
          }
        });
      }
    }else{
      this.userReaction =  "NONE";
    }
  }

  onReaction(reaction: string) {
    if (this.userReaction) {
      if (this.userReaction === reaction) {
        this.reaction.emit({ "id": this.id, "reaction": reaction, "action": "REMOVE"});
      } else {
        this.reaction.emit({ "id": this.id, "reaction": reaction, "oldReaction": this.userReaction, "action" : "CHANGE" });
      }
    } else {
      this.reaction.emit({ "id": this.id, "reaction": reaction ,"action" : "ADD"});
    }
  }

}
